import React, { useRef, useEffect } from "react";
import cn from 'classnames';
import useWindowDimensions from "@helpers/hooks/windowDemensions";
import './style.css';

const FrameSelector = ({ frameChoose, frameSelected }) => {

  const { width } = useWindowDimensions();
  const wrapperRef = useRef(null);

  // Scroll to start on mount (fixes RTL page context issue)
  useEffect(() => {
    if (wrapperRef.current && width <= 767) {
      wrapperRef.current.scrollLeft = 0;
    }
  }, [width]);

  const Frames = [
    {
      name: "classic",
      img: "assets/file/images/d1.png",
      text: "קלאסי",
      label: "פופולארי",
    },
    {
      name: "bold",
      img: "assets/file/images/d2.png",
      text: "נועז",
    },
    {
      name: "ever",
      img: "assets/file/images/d3.png",
      text: "נקי",
    },
    {
      name: "clean",
      img: "assets/file/images/d4.png",
      text: "אותנטי",
    },
    {
      name: "village",
      img: "assets/file/images/d5.png",
      text: "כפרי",
      label: "חדש",
    },
    {
      name: "nordic",
      img: "assets/file/images/d6.png",
      text: "נורדי",
      label: "חדש",
    },
  ];
  return (
    <div className="frame-wrapper" dir="ltr" ref={wrapperRef}>
      {Frames.map((frame) => (
        <div
          key={frame.name}
          className={cn("frame-wrapper__item", { last: frameChoose === frame.name })}
          onClick={() => frameSelected(frame.name)}
        >
          {/* Desktop */}
          {width > 767 && <>
            <img src={frame.img} className="w-100" alt="" />
            <p>{frame.text}</p>
            {frame.label && <span className={frame.label === "חדש" ? "new" : "popular"}>{frame.label}</span>}
          </>}
          {/* Mobile */}
          {width <= 767 && <>
            {frame.label && <span className={frame.label === "חדש" ? "new" : "popular"}>{frame.label}</span>}
            <img src={frame.img} className="w-65" alt="" />
            <p>{frame.text}</p>
          </>}
        </div>
      ))}
    </div>
  );
};

export default FrameSelector;
